import React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import OnBoardModal from './components/OnBoardModal';

export const openOnBoardModal = options => {
  confirmAlert({
    overlayClassName: 'onboard-overlay',
    closeOnClickOutside: false,
    customUI: ({ onClose }) => <OnBoardModal onClose={onClose} {...options} />,
  });
};

export const scrollToElement = el => {
  const coordinates = document.querySelector(el)?.getBoundingClientRect();
  if (!coordinates) return;
  document.querySelector('html').scrollTop = coordinates.y - 30;
};
